export default __webpack_public_path__ + "static/media/Group8402.c6cc019a.svg";